$.houdiniforms = {messages : {}};

$.extend( $.houdiniforms.messages, {
	steps_cancel: "Cancel",
	steps_current: "current step:",
	steps_pagination: "Pagination",
	steps_finish: "Finish",
	steps_next: "Next",
	steps_previous: "Previous",
	steps_loading: "Loading ..."
} );